//#region src/app-manifest.ts
/**
* The release kinds of an `app.json` (2026-10-12-shared-libraries, D6). `app` is every app today. A
* `library` is code that consuming apps use: it shares the `release.apps` record, the slug name
* space, owners, channels and the publish route, and never deploys as an app itself. A third kind,
* `instance`, exists only on the CP record and never in a manifest (R-002).
*/
const APP_KINDS = Object.freeze(["app", "library"]);
/**
* The instancing modes of a library (D7). `perConsumer`: one instance per consuming app per data
* plane. `shared` is reserved: the schema admits it so that the publish door refuses it with a
* named error, and nothing implements it.
*/
const LIBRARY_INSTANCING_MODES = Object.freeze(["perConsumer", "shared"]);
/** The reserved instancing mode the publish door refuses (D7). */
const LIBRARY_INSTANCING_RESERVED = "shared";
/**
* The kind of `manifest`: its `kind`, or `app` when the member is absent, so every manifest from
* before the member reads as an app. Pure.
*/
function appKindOf(manifest) {
	return manifest.kind ?? "app";
}
/**
* The grammar of one org role slug as `app.json` `permissions[].defaultRoles` names it, mirrored
* by `$defs/permission.properties.defaultRoles.items.pattern` in `app-manifest.schema.json` and by
* the CP-DP wire schema. The DP stores a role slug in `auth.org_role_definitions.slug`, a
* `varchar(64)`, so the bound is 64 characters.
*/
const ORG_ROLE_SLUG_PATTERN = /^[a-z][a-z0-9_-]{0,63}$/;
/**
* The most role slugs one `defaultRoles` list may name (zion-cli-integrate-verbs R-035), mirrored
* by `maxItems` in `app-manifest.schema.json` and by `.max()` on the CP-DP wire schema. The DP
* onboard step runs one grant per (key, slug) pair, so this is the bound on that loop.
*/
const DEFAULT_ROLES_MAX = 16;
//#endregion
export { APP_KINDS, DEFAULT_ROLES_MAX, LIBRARY_INSTANCING_MODES, LIBRARY_INSTANCING_RESERVED, ORG_ROLE_SLUG_PATTERN, appKindOf };

//# sourceMappingURL=app-manifest.js.map